'use strict';
var employeeList = document.querySelector('ul');
var toNumber = function(salaryStr) {
    return Number(salaryStr.replace(/[$,]/g, ''));
};
function sortList(list) {
    var items = Array.from(list.querySelectorAll('li'));
    items.sort(function(a, b) {
        var salaryA = toNumber(a.dataset.salary);
        var salaryB = toNumber(b.dataset.salary);
        return salaryB - salaryA;
    });
    items.forEach(function(item) {
        return list.append(item);
    });
}
function getEmployees(list) {
    var items = Array.from(list.querySelectorAll('li'));
    return items.map(function(item) {
        return {
            name: item.innerText.trim(),
            position: item.dataset.position,
            salary: toNumber(item.dataset.salary),
            age: Number(item.dataset.age)
        };
    });
}
sortList(employeeList);
getEmployees(employeeList);

//# sourceMappingURL=js_task_parse_list_DOM.81374f3c.js.map
